export const chatsInitialState = {
  chats: {
    users_list: [],
    cred_list: [],
    account_list: [],
    chat_list: [],
    selected_cred_id: null,
    selectedAccountId: null,
    selectedUserId: null,
    is_loading: false,
    accounts_meta: {
      isLoading: false,
      hasError: false,
      loaded: false
    },
    meta: {
      isLoading: false,
      hasError: false,
      loaded: true,
      withoutNavbar: true
    },
    users_meta: {
      isLoading: false,
      hasError: false,
      loaded: true
    },
    chat_meta: {
      isLoading: false,
      hasError: false,
      loaded: true
    }
  }
};
